import { gqlFetcher, graphql } from '#features/api';

const logoutDoc = graphql(`
  mutation Logout {
    auth {
      logout {
        __typename
        ... on Operation {
          status
        }
        ... on GlobalError {
          errorCode
          errorMessage
        }
      }
    }
  }
`);

/**
 * Завершить сеанс в реестре устройств. Лучшее усилие: выход не вправе зависеть от ответа
 * шлюза — куку и токен клиент снимет сам, а незавершённый сеанс протухнет по бездействию.
 */
export const endSession = () => gqlFetcher(logoutDoc, null, { silent: true }).catch(() => undefined);
